import React from "react";
import { Typography, SxProps } from "@mui/material";
import { Colors } from "../../Constants/Colors";
import { ComponentConfig } from "../../Config/ComponentConfig.js";

interface TitleWithBodyProps {
  title: string;
  subtitle?: string;
  titleStyle?: SxProps;
  subtitleStyle?: SxProps;
}

const TitleWithBody: React.FC<TitleWithBodyProps> = ({
  title,
  subtitle,
  titleStyle,
  subtitleStyle,
}) => {
  return (
    <div>
      {/* Title  */}
      <Typography
        sx={{
          color: Colors.primaryTextColor,
          fontSize: ComponentConfig.fonts.subtitleBold.fontSize,
          fontWeight: ComponentConfig.fonts.subtitleBold.fontWeight,
          ...titleStyle,
        }}
      >
        {title}
      </Typography>

      {/* Subtitle */}
      {subtitle && (
        <Typography
          sx={{
            fontSize: ComponentConfig.fonts.smallRegular.fontSize,
            fontWeight: ComponentConfig.fonts.smallRegular.fontWeight,
            color: Colors.lightGrey,
            ...subtitleStyle,
          }}
        >
          {subtitle}
        </Typography>
      )}
    </div>
  );
};

export default TitleWithBody;
